/* eslint-disable react-hooks/exhaustive-deps */
import { log } from '@/utils/log';
import { useState, useCallback, useEffect } from 'react';
import { useRequest } from 'umi';
import * as apis from '../apis/apis';
import {
  watchdogPercentEventSuccess,
  watchdogPercentEventFail,
} from '@/utils/watchdog-percent';
import { getCityByAmapGeolocation } from '@/plugins/amap';

interface IFee {
  billType: number;
  sort: number;
  [props: string]: any;
}
interface IConfig {
  basicFees: IFee[]; // 基础费用配置
  extraFees: IFee[]; // 额外费用配置
  onePricePackage: number[]; // 专享价配置
}

export default function OrderCenterSameCityShippingCity() {
  const [cityList, setCityList] = useState<any[]>([]); // 开城-城市列表
  const [selectedCity, setSelectedCityId] = useState<number | undefined>(
    undefined
  ); // 选中城市id
  const [cityName, setCityName] = useState<string>(''); // 选中城市名称
  const [isSelectedHot, setHot] = useState<boolean>(false); // 是否选中的是热门城市
  const [resetSign, setResetSign] = useState<boolean>(false); // 重置数据标识
  const [locationCity, setLocationCity] = useState<any>({}); // 根据定位匹配到的开城城市-如果不是开城城市则为空对象
  const [locationCityName, setLocationCityName] = useState<string>(''); // 定位得到的城市名称（不一定在城市列表中）
  const [locationStatus, setLocationStatus] = useState<
    // 当前定位的状态 loading: 定位中 failed: 定位失败 success: 定位成功 ''还未开始定位。
    'success' | 'loading' | 'failed' | ''
  >(''); // 定位状态
  // const [locateCityName, setLocateCityName] = useState<string>('');
  const [config, setConfig] = useState<IConfig | null>(null); // 专享价配置
  const resGetCityList = useRequest(apis.getOpenedCityList, {
    manual: true,
    onSuccess: (data) => {
      watchdogPercentEventSuccess('开城城市列表');
      setCityList(data.cityItem);
      if (selectedCity) {
        const { name } = data.cityItem.filter(
          (i: any) => i.cityId === selectedCity
        )[0];
        setCityName(name);
      }
    },
    onError: (error) => {
      watchdogPercentEventFail('开城城市列表', {
        message: error?.message,
      });
    },
  });

  const setCityListCb = useCallback((val) => {
    setCityList(val);
  }, []);
  const setSelectedCity = useCallback((val) => {
    log.log('setSelectedCity selectedcity', val);
    setSelectedCityId(val);
  }, []);
  const setHotSelected = useCallback((val) => {
    setHot(val);
  }, []);
  const getCityList = () => {
    resGetCityList.run();
  };
  // const set = useCallback((val) => {
  //   log.log('set selectedcity', val);
  //   setSelectedCityId(val);
  // }, []);
  const reset = useCallback(() => {
    setResetSign(true);
  }, []);
  const setResetSignCb = useCallback((val) => {
    setResetSign(val);
  }, []);

  const isOpenedCity = useCallback(
    (val, type = 'id') => {
      const keyVal = type === 'id' ? 'cityId' : 'name';
      const filterItem = cityList.filter((item) => {
        return item[keyVal] === val;
      });
      return !!filterItem.length;
    },
    [cityList]
  );

  const setConfigCb = useCallback(setConfig, []);

  const getCityId = useCallback(
    (val) => {
      let cityId;
      const filterList = cityList.filter((item) => item.name === val);
      if (filterList.length) {
        cityId = filterList[0].cityId;
      }
      return cityId;
    },
    [cityList]
  );

  const setCityNameCb = useCallback((val: string) => {
    setCityName(val);
  }, []);

  useEffect(() => {
    if (cityList?.length && locationCityName) {
      const name = locationCityName.replace(/市$/, '');
      const item = cityList.filter((i: any) => i.name === name);
      if (item.length) {
        setLocationCity(item[0]);
      }
    } else if (locationCityName && !cityList?.length) {
      resGetCityList.run();
    }
  }, [locationCityName, cityList]);
  const getLocationCity = useCallback(async () => {
    setLocationStatus('loading');
    try {
      const city = await getCityByAmapGeolocation();
      const name = String(city ?? '').trim();
      if (!name) {
        throw new Error('城市为空');
      }
      log.log('定位', name);
      setLocationCityName(name);
      setLocationStatus('success');
    } catch (err) {
      log.log('定位失败', err);
      setLocationCityName('深圳');
      setLocationStatus('failed');
    }
  }, [cityList]);
  return {
    cityName,
    cityList,
    selectedCity,
    isSelectedHot,
    resetSign,
    locationCity,
    locationCityName,
    locationStatus,
    setCityListCb,
    setSelectedCity,
    setHotSelected,
    getCityList,
    isOpenedCity,
    setCityNameCb,
    // set,
    getCityId,
    reset,
    getLocationCity,
    setResetSignCb,
    config,
    setConfigCb,
  };
}
